/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Agent } from '../models/agent';
import { AgentList } from '../models/agent-list';
import { AgentsEventsPaginatedList } from '../models/agents-events-paginated-list';
import { createAgent } from '../fn/administration-agent/create-agent';
import { CreateAgent$Params } from '../fn/administration-agent/create-agent';
import { getAgent } from '../fn/administration-agent/get-agent';
import { GetAgent$Params } from '../fn/administration-agent/get-agent';
import { getAgents } from '../fn/administration-agent/get-agents';
import { GetAgents$Params } from '../fn/administration-agent/get-agents';
import { searchAgentsEvents$Any } from '../fn/administration-agent/search-agents-events-any';
import { SearchAgentsEvents$Any$Params } from '../fn/administration-agent/search-agents-events-any';
import { searchAgentsEvents$Json } from '../fn/administration-agent/search-agents-events-json';
import { SearchAgentsEvents$Json$Params } from '../fn/administration-agent/search-agents-events-json';
import { updateAgent } from '../fn/administration-agent/update-agent';
import { UpdateAgent$Params } from '../fn/administration-agent/update-agent';


/**
 * All about the administration agent features
 */
@Injectable({ providedIn: 'root' })
export class AdministrationAgentService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAgents()` */
  static readonly GetAgentsPath = '/agents';

  /**
   * Retrieve a list of agents, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAgents()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAgents$Response(params?: GetAgents$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentList>> {
    return getAgents(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a list of agents, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAgents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAgents(params?: GetAgents$Params, context?: HttpContext): Observable<AgentList> {
    return this.getAgents$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentList>): AgentList => r.body)
    );
  }

  /** Path part for operation `createAgent()` */
  static readonly CreateAgentPath = '/agents';

  /**
   * Create an agent.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAgent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAgent$Response(params: CreateAgent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createAgent(this.http, this.rootUrl, params, context);
  }

  /**
   * Create an agent.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAgent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAgent(params: CreateAgent$Params, context?: HttpContext): Observable<void> {
    return this.createAgent$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAgent()` */
  static readonly GetAgentPath = '/agents/{uid}';

  /**
   * Retrieve an agent.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAgent()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAgent$Response(params: GetAgent$Params, context?: HttpContext): Observable<StrictHttpResponse<Agent>> {
    return getAgent(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve an agent.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAgent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAgent(params: GetAgent$Params, context?: HttpContext): Observable<Agent> {
    return this.getAgent$Response(params, context).pipe(
      map((r: StrictHttpResponse<Agent>): Agent => r.body)
    );
  }

  /** Path part for operation `updateAgent()` */
  static readonly UpdateAgentPath = '/agents/{uid}';

  /**
   * Update an agent.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAgent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAgent$Response(params: UpdateAgent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateAgent(this.http, this.rootUrl, params, context);
  }

  /**
   * Update an agent.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAgent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAgent(params: UpdateAgent$Params, context?: HttpContext): Observable<void> {
    return this.updateAgent$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `searchAgentsEvents()` */
  static readonly SearchAgentsEventsPath = '/agents/events/search';

  /**
   * search agents events.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchAgentsEvents$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchAgentsEvents$Json$Response(params?: SearchAgentsEvents$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentsEventsPaginatedList>> {
    return searchAgentsEvents$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * search agents events.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchAgentsEvents$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchAgentsEvents$Json(params?: SearchAgentsEvents$Json$Params, context?: HttpContext): Observable<AgentsEventsPaginatedList> {
    return this.searchAgentsEvents$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentsEventsPaginatedList>): AgentsEventsPaginatedList => r.body)
    );
  }

  /**
   * search agents events.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchAgentsEvents$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchAgentsEvents$Any$Response(params?: SearchAgentsEvents$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentsEventsPaginatedList>> {
    return searchAgentsEvents$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * search agents events.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchAgentsEvents$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchAgentsEvents$Any(params?: SearchAgentsEvents$Any$Params, context?: HttpContext): Observable<AgentsEventsPaginatedList> {
    return this.searchAgentsEvents$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentsEventsPaginatedList>): AgentsEventsPaginatedList => r.body)
    );
  }

}
